import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  IWarehouseListData,
  IWarehouseRequestResponse,
} from '../../models/warehouse/warehouse.model';
import useHttps from '../useHttps';

const useListWarehouses = () => {
  const request = useHttps();
  const [warehouseListloading, setWarehouseListLoading] = useState(false);
  const [listOfWarehouses, setListOfWarehouses] = useState<any>();

  useEffect(() => {
    const getWarehouses = () => {
      const url: HttpConfig = {
        url: 'warehouse-service/api/v1/warehouses?page=0&size=1000',
        method: 'get',
      };

      request(
        url,
        onListWarehousesSuccess,
        setWarehouseListLoading,
        onListWarehousesError
      );
    };
    getWarehouses();
  }, [request]);

  const onListWarehousesError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const onListWarehousesSuccess = ({
    message,
    data,
  }: SuccessHttpResponse<IWarehouseRequestResponse>) => {
    // console.log('data--->>', data);
    const wareHouseIdsList = data.records.map((data: IWarehouseListData) => ({
      name: data.name,
      id: data.id,
    }));
    setListOfWarehouses(wareHouseIdsList);
    // toast.success(message);
  };

  return { listOfWarehouses, warehouseListloading };
};

export default useListWarehouses;
